import { Component, type ReactNode } from 'react';
import { Button } from '@/components/ui';

/** Keeps one broken screen from blanking the whole app; resets when the route changes. */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }
  componentDidCatch(error: Error) {
    console.error('Screen crashed:', error);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex flex-col items-center gap-3 p-10 text-center">
        <div className="text-lg font-semibold">Something went wrong on this screen</div>
        <div className="max-w-lg text-sm text-subtle">{this.state.error.message}</div>
        <Button variant="outline" onClick={() => this.setState({ error: null })}>
          Try again
        </Button>
      </div>
    );
  }
}
